import type { FaireProductEntity } from "../../entity_types/product";

export const p_jecyeecy8b: FaireProductEntity = {
  token: "p_jecyeecy8b",
  type: "product",
  name: "Bride Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/629eca21aceb463e257af822782b4bdd585c06fd7cd231e38c1241231bb1ad74.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/136f1299a0446b22164bc10a0acec27dc9a8ba6dd1143bdf9f765d6d4a9c3e4a.jpeg",
    "https://cdn.faire.com/fastly/dda43febfa6a7a5e7332e876fcd6466d645c02bff6b5db77d6e8f501a78e9398.jpeg",
    "https://cdn.faire.com/fastly/3939c9867e98def82bdff61083c489236c52c57662dbda2375eed30b3a29605d.jpeg",
    "https://cdn.faire.com/fastly/d3d9775938580dccb88a23eccae2c0acd43402057e767da46601c27e13e4c988.jpeg",
    "https://cdn.faire.com/fastly/19c1c3af7074e483d3989386d91c233dcc7fe2dd7532afe6fb44680a81125254.jpeg"
  ],
  priceDollars: 6.75,
  description: "She's pulling off the party of a lifetime with everyone she loves (and her parents' friends for some reason). These comfy socks make the perfect gift for the bride, whether they're tucked into a bridal shower gift, worn while getting ready, or packed for the honeymoon. Nothing says \"I'm in charge here\" like these baddies. 🧦 \n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance.\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:33:17.899Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
